var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1333 50.4669H34.1333V37.0003L39.6 42.4669L42.4 39.6669L32 29.5336L21.7333 39.8003L24.5333 42.6003L30.1333 37.0003V50.4669ZM14.8 59.0669C13.6 59.0669 12.5444 58.6114 11.6333 57.7003C10.7222 56.7892 10.2667 55.7336 10.2667 54.5336V9.46693C10.2667 8.22248 10.7222 7.15582 11.6333 6.26693C12.5444 5.37804 13.6 4.93359 14.8 4.93359H38.9333L53.7333 19.7336V54.5336C53.7333 55.7336 53.2889 56.7892 52.4 57.7003C51.5111 58.6114 50.4444 59.0669 49.2 59.0669H14.8ZM36.6 21.8669V9.46693H14.8V54.5336H49.2V21.8669H36.6ZM14.8 9.46693V21.8669V9.46693V54.5336V9.46693Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.638fc773338f397f1cd621140659dc53.svg";
export { ForwardRef as ReactComponent };